export const hero = {
  "title": "Exchange between hosts,",
  "titleHighlight": "across Europe",
  "subtitle": "European exchange club for Airbnb hosts rated 4.5+ with a single Europe plan.",
  "cta": "Start Exchanging",
  "learnMore": "Learn More",
  "stats": {
    "owners": "Active Owners",
    "countries": "Available Countries",
    "exchanges": "Completed Exchanges"
  },
  "slogans": {
    "slogan1": {
      "title": "Private club",
      "highlight": "Airbnb hosts 4.5+",
      "subtitle": "Access is reserved to well-rated hosts to keep exchanges trusted and reliable."
    },
    "slogan2": {
      "title": "2026 launch offer",
      "highlight": "50% off for first 1,000",
      "subtitle": "EUR25/year instead of EUR50/year, with a lifetime guaranteed price."
    },
    "slogan3": {
      "title": "Lifetime price guarantee",
      "highlight": "First 1,000 members",
      "subtitle": "The first 1,000 members keep this rate for life."
    },
    "slogan4": {
      "title": "No middlemen,",
      "highlight": "just connection",
      "subtitle": "A trusted community where members exchange stays, not nightly rentals."
    },
    "slogan5": {
      "title": "Join the club",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "The exchange club designed for active Airbnb hosts in Europe."
    },
    "slogan6": {
      "title": "Low season",
      "highlight": "optimized",
      "subtitle": "Turn low-demand periods into travel opportunities through exchanges."
    },
    "slogan7": {
      "title": "Take a break,",
      "highlight": "avoid burnout",
      "subtitle": "Recharge between hosting periods by exchanging your home."
    },
    "slogan8": {
      "title": "The spirit of travel,",
      "highlight": "the real one",
      "subtitle": "Meet other hosts and discover new places at lower vacation cost."
    },
    "slogan9": {
      "title": "100% Made in France",
      "highlight": "(Picardy)",
      "subtitle": "Not Silicon Valley, but the Upper Somme Valley. An artisanal, human platform proud of its roots."
    }
  }
};
